var e = /* @__PURE__ */ ((t) => (t.STANDARD = "standard", t.HELP_TEXT = "help-text", t.QUESTION = "question-text", t.INFO_DESCRIPTOR = "info-descriptor", t.ERROR = "error", t.HOVER_HELP = "hover-help", t.TITLE_TEXT = "title-text", t.READ_ONLY_INPUT = "read-only-input", t))(e || {});
export {
  e as TEXT_DISPLAY_VARIANTS
};
//# sourceMappingURL=text-display-variants.js.map
